import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'pur-credit-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'pur-credit-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'pur-credit-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'pur-credit-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'pur-credit-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'pur-credit-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'pur-credit-overview__menu--activity',
    informations: 'pur-credit-overview__menu--general-info',
    financialactivity: 'pur-credit-overview__menu--financial-info',
    contacts: 'pur-credit-overview__menu--contact-linked',
    addresses: 'pur-credit-overview__menu--address',
    customfields: 'pur-credit-overview__menu--cf',
    statistics: 'pur-credit-overview__menu--stat',
    opportunity: 'pur-credit-overview__menu--opportunity',
    estimate: 'pur-credit-overview__menu--document',
    invoice: 'pur-credit-overview__menu--document',
    delivery: 'pur-credit-overview__menu--document',
    order: 'pur-credit-overview__menu--document',
    creditnote: 'pur-credit-overview__menu--document',
    proforma: 'pur-credit-overview__menu--document',
    payments: 'pur-credit-overview__menu--payment',
    bankaccount: 'pur-credit-overview__menu--bank-account',
    recurring: 'pur-credit-overview__menu--recurring',
    mandates: 'pur-credit-overview__menu--mandate',
    timetracking: 'pur-credit-overview__menu--timetracking',
    tickets: 'pur-credit-overview__menu--ticket',
    project: 'pur-credit-overview__menu--project',
    proposal: 'pur-credit-overview__menu--proposal',
    emailingprofile: 'pur-credit-overview__menu--mailing-list',
    massmailingMailinglist: 'pur-credit-overview__menu--mailing-list',
    massmailingCampaignList: 'pur-credit-overview__menu--mailing-list',
    receipts: 'pur-credit-overview__menu--receipt',
    briefcase: 'pur-credit-overview__menu--briefcase',
    activitycommentadd: 'pur-credit-overview__activity--comment-add',
    emailadd: 'pur-credit-overview__activity--email-add',
    calladd: 'pur-credit-overview__activity--call-add',
    taskadd: 'pur-credit-overview__activity--task-add',
    eventadd: 'pur-credit-overview__activity--event-add',
    generalinfoedit1: 'pur-credit-overview__section--general-info-edit-1',
    generalinfoedit2: 'pur-credit-overview__section--general-info-edit-2',
    marketing: 'pur-credit-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
